import React, { FunctionComponent } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';
import { ThemeProvider as FormThemeProvider } from '@lyse-as/formds-react';

import { ErrorBoundary } from 'src/components/error-boundary';
import { Footer } from 'src/components/footer';
import { Header } from 'src/components/header';
import { useNavPromptWhileOrdering } from 'src/state/order/hooks';

import { StyledApp, StyledContent } from './app.styled';

export const App: FunctionComponent = () => {
  useNavPromptWhileOrdering();

  return (
    <FormThemeProvider layer="canvas" scheme="primary" textTone="neutral" asChild={true}>
      <StyledApp>
        <Header />
        <StyledContent>
          <ErrorBoundary>
            <ScrollRestoration />
            <Outlet />
          </ErrorBoundary>
        </StyledContent>
        <Footer />
      </StyledApp>
    </FormThemeProvider>
  );
};
